import axios from 'axios';
import React from 'react'
import { redirect } from 'react-router-dom';

export default function Callback() {
  return (
    <div>Waiting for login</div>
  )
}

interface loader {
    request: Request;
    params: {};
}

export async function callbackLoader(data: loader) {
    const url = new URL(data.request.url);
    const code = url.searchParams.get('code');
    const res = await axios({
        url: `${process.env.REACT_APP_BASE_URL ?? 'http://localhost:5000/api/'}admin/create`,
        method: 'POST',
        data: {
            code,
        }
    })
    if (res.data.success) {
        localStorage.setItem('admin_rezvan_token', res.data.result);
        return redirect("/");
    }
}
